import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import CountryGuides from "./index";
import { Globe } from "lucide-react";
import { MODULE_COUNTRY_GUIDE } from "variables/constants";

const countryGuideRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Country Guide",
        basePath: "country-guide",
        mainComponent: <CountryGuides />,
        layout: "/console",
        icon: <Globe className="icon-item" />,
        subTitle:"Country Guide",
        level:4,
        moduleId: MODULE_COUNTRY_GUIDE,
    })
];

export default countryGuideRoutes;